export default "__VITE_ASSET__HvBR5f6___"